import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'
import { reduxForm, Field } from 'redux-form'
import {
  Button,
} from 'react-bootstrap'
import CardTemplateField from 'components/CardTemplateField'

export class ApplyTemplateForm extends React.Component {
  static propTypes = {
    boardId: PropTypes.number.isRequired,

    handleSubmit: PropTypes.func.isRequired,
  }

  handleKeyDown = (event) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      this.props.handleSubmit()
    }
  }

  renderTemplateField = (field) => {
    return (
      <CardTemplateField
        boardId={this.props.boardId}
        value={field.input.value}
        onChange={field.input.onChange}
      />
    )
  }

  render () {
    const {
      handleSubmit,
    } = this.props

    return (
      <form onSubmit={handleSubmit}>
        <Field
          name='template'
          component={this.renderTemplateField}
        />
        <Button type='submit' bsStyle='primary'><FormattedMessage id='CARD_APPLY_TEMPLATE_BUTTON' /></Button>
      </form>
    )
  }
}

export default reduxForm({
  form: 'applyCardTemplateForm',
  initialValues: {
    template: null,
  }
})(ApplyTemplateForm)
